import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content bg-light rounded-card px-3 px-sm-4 py-3" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title fw-bold",
  id: "exampleModalLabel"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close bg-info text-light rounded-pill px-3 opacity-100",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  id: "carouselExampleControls",
  class: "carousel slide"
}
const _hoisted_8 = {
  key: 0,
  class: "carousel-inner px-4"
}
const _hoisted_9 = { class: "ratio ratio-4222x3101" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev w-20-px\" type=\"button\" data-bs-target=\"#carouselExampleControls\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon text-secondary\" aria-hidden=\"true\"><i class=\"fa fa-4x fa-caret-left opacity-75\"></i></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next w-20-px\" type=\"button\" data-bs-target=\"#carouselExampleControls\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon text-secondary\" aria-hidden=\"true\"><i class=\"fa fa-4x fa-caret-right opacity-75\"></i></span><span class=\"visually-hidden\">Next</span></button>", 2)

import { ref, onMounted } from "vue";


const __default__ = {
  name: "ShowImagesModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const title = ref();
const images = ref();
const imagesModal = ref();

onMounted(() => {
  imagesModal.value.addEventListener("show.bs.modal", (event) => {
    title.value = event.relatedTarget.getAttribute("data-bs-title");
    images.value = JSON.parse(
      event.relatedTarget.getAttribute("data-bs-images")
    );
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "imagesModal",
    ref: imagesModal,
    class: "modal fade",
    id: "showImagesModal",
    tabindex: "-1",
    "aria-labelledby": "exampleModalLabel",
    "aria-hidden": "true",
    "data-bs-touch": "false",
    "data-bs-interval": "false"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, _toDisplayString(title.value), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (images.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (img, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["carousel-item", { active: i === 0 }])
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: img,
                          class: "d-block w-100",
                          alt: img,
                          style: {"object-fit":"contain"}
                        }, null, 8, _hoisted_10)
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_11
          ])
        ])
      ])
    ])
  ], 512))
}
}

})